import React, {useId, useState} from 'react';
import {Box, Collapse, Link, Typography} from '@mui/material';

export const FilingFeeSummary = ({total, rows, onExpand}: {
    total: string | null;
    rows: {label: string; amount: string | null}[];
    onExpand?: () => void;
}) => {
    const [expanded, setExpanded] = useState(false);
    const breakdownId = useId();

    return <>
        <Box sx={{display: 'flex', justifyContent: 'space-between', gap: 2, alignItems: 'baseline'}}>
            <Typography component="h2" sx={{fontSize: '1.25rem', fontWeight: 700}}>Filing fee</Typography>
            <Typography aria-live="polite" sx={{fontSize: '1.5rem', fontWeight: 700}}>{total ?? 'Updating…'}</Typography>
        </Box>
        <Typography variant="caption" color="text.secondary">
            * Includes all state filing and late fees. -{' '}
            <Link component="button" type="button" variant="inherit" color="inherit" underline="none"
                  aria-expanded={expanded} aria-controls={breakdownId}
                  onClick={() => {if (!expanded) onExpand?.(); setExpanded(!expanded);}} sx={{verticalAlign: 'baseline', whiteSpace: 'nowrap'}}>
                {expanded ? 'hide breakdown' : 'view breakdown'}
            </Link>
        </Typography>
        <Collapse in={expanded}>
            <Box id={breakdownId} sx={{borderTop: '1px solid', borderColor: 'divider', py: 1}}>
                {rows.map(({label, amount}) => <Box key={label} sx={{display: 'flex', justifyContent: 'space-between', gap: 2, py: 0.5}}>
                    <Typography variant="body2">{label}</Typography>
                    <Typography variant="body2">{amount}</Typography>
                </Box>)}
            </Box>
        </Collapse>
    </>;
};
